import React from 'react';
import './Events.css';
import garageSaleImage from '../images/GarageSaleSep14.jpg';
import parksidePicksImage from '../images/parksidepicks.jpg';

const Events = () => {
  const upcomingEvents = [];

  const pastEvents = [
    {
      title: 'Parkside Picks - Charity Sale Event',
      date: 'Oct 4-5, 2025',
      location: 'Frank Fisher Park, Fremont',
      description: '🌟 Successful Community Charity Sale! 🌟\n\nMore than 10+ enthusiastic kids volunteered over the weekend, making this charity sale event a tremendous success! The event took place on Saturday and Sunday at Frank Fisher Park, where young volunteers demonstrated incredible dedication and community spirit.\n\nWith great support from both the participating children and their parents, the event created a vibrant atmosphere in the park. The young volunteers managed various aspects of the sale, from organizing items to engaging with community members, showcasing their commitment to making a difference.',
      closingMessage: 'Thank you to all the young volunteers, supportive parents, and community members who contributed to making this charity event a success!',
      impact: 'Community fundraising event with 10+ youth volunteers',
      image: parksidePicksImage
    },
    {
      title: 'Garage Sale - Help a Child Learn',
      date: '14-Sep-2025',
      location: '34723 Woodhue Ter, Fremont, California. USA',
      description: '🌟 Successful Charity Garage Sale - Making Dreams Come True! 🌟\n\nWe are delighted to announce that our recent charity garage sale was a tremendous success! Our young participants showed incredible enthusiasm and dedication, successfully raising funds for a noble cause.\n\nThe funds collected will support the education of twin girls from India whose family faces significant challenges. Their father is physically challenged, and their siblings are living with autism. After a personal visit to the family, we committed to supporting these bright young girls\' education journey from 6th grade through graduation.\n\nWe extend our heartfelt gratitude to:\n\n• All the children who participated\n• Parents who supported this initiative\n• Community members who contributed\n• Everyone who made purchases at the sale',
      closingMessage: 'Your generosity will help create educational opportunities and a brighter future for these deserving young students.\n\nTogether, we continue to make a difference, one event at a time!',
      impact: 'Funds raised for twin girls education',
      image: garageSaleImage
    }
  ];

  return (
    <section className="events">
      <div className="container">
        <div className="events-content">
          
          {/* Upcoming Events Section */}
          <div className="events-section">
            <h2>Upcoming Events</h2>
            <div className="events-grid">
              {upcomingEvents.length === 0 ? (
                <div className="no-events">
                  <p>No upcoming events at this time. Check back soon!</p>
                </div>
              ) : (
                upcomingEvents.map((event, index) => (
                <div key={index} className={`event-card upcoming ${event.image ? 'with-image' : ''}`}>
                  <div className="event-date">
                    <span className="date">{event.date}</span>
                    <span className="time">{event.time}</span>
                  </div>
                  <div className="event-content">
                    <div className="event-details">
                      <h3>{event.title}</h3>
                      <p className="location">📍 {event.location}</p>
                      <p className="description">{event.description}</p>
                    </div>
                    {event.image && (
                      <div className="event-image">
                        <img src={event.image} alt={event.title} />
                      </div>
                    )}
                  </div>
                </div>
              ))
              )}
            </div>
          </div>

          {/* Past Events Section */}
          <div className="events-section">
            <h2>Past Events</h2>
            <div className="events-grid">
              {pastEvents.length === 0 ? (
                <div className="no-events">
                  <p>No past events to display at this time.</p>
                </div>
              ) : (
                pastEvents.map((event, index) => (
                  <div key={index} className="event-card past with-image">
                    <div className="event-date">
                      <span className="date">{event.date}</span>
                    </div>
                    <div className="event-content">
                      <div className="event-details">
                        <h3>{event.title}</h3>
                        <p className="location">📍 {event.location}</p>
                        <p className="description">{event.description}</p>
                        {!event.closingMessage && (
                          <div className="event-impact">
                            <span className="impact-badge">{event.impact}</span>
                          </div>
                        )}
                      </div>
                      {event.image && (
                        <div className="event-image">
                          <img src={event.image} alt={event.title} />
                        </div>
                      )}
                    </div>
                    {event.closingMessage && (
                      <div className="event-footer">
                        <p className="closing-message">{event.closingMessage}</p>
                        <div className="event-impact">
                          <span className="impact-badge">{event.impact}</span>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Events;